import { Pipe, PipeTransform } from '@angular/core';
import { getPerformaceYearsCollection } from '@shared/utils/data.utils';

@Pipe({ standalone: false, name: 'performanceYear' })
export class PerformanceYearPipe implements PipeTransform {
  transform(value: number): string {
    if (value === null || value === undefined) {
      return '';
    }

    const year = getPerformaceYearsCollection().find(item => item.id === value);

    return year?.title ?? '';
  }
}
